export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_9-a9882f91150cdf7cf2d0708b8293e68e.jpg";